"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var useConfig_1 = __importDefault(require("../../../_util/useConfig"));
function AnimAudio() {
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    return (react_1.default.createElement("div", { className: "".concat(classPrefix, "-audio-anim") },
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { style: {
                    background: 'url(https://staticintl.cloudcachetci.com/cms/backend-cms/rYUh919_111.png)',
                }, className: "audio-anim-loop is-enter " }),
            react_1.default.createElement("img", { className: "audio-anim-img", src: "https://test-staticintl.cloudcachetci.com/cms/backend-cms/M43b335_02.png" }),
            react_1.default.createElement("img", { className: "audio-anim-img-bg", src: "https://test-staticintl.cloudcachetci.com/cms/backend-cms/TLH8860_03.png" }),
            react_1.default.createElement("img", { className: "audio-anim-img-bg1", src: "https://test-staticintl.cloudcachetci.com/cms/backend-cms/Raxm431_bg2.png" }))));
}
exports.default = AnimAudio;
//# sourceMappingURL=index.js.map